export default __webpack_public_path__ + "static/media/runningheart.742aff4d.gif";